import * as React from 'react'
import { Star } from 'react-feather'

import { INetworkFilterFormOption, useWhitelabel } from 'main/framework'
import { Strong, Text } from 'main/ui'
import { AssetName } from 'main/util/asset'
import { useTranslation } from 'react-i18next'
import { LOCIZE_NAMESPACE } from '../../../common'

import Bullet from '../common/Bullet'
import { i18nKeyPrefix } from '../i18n'
import { LinkWithLeftPaddingSometimes, SpaceBetweenFlexSpan } from './Basics.styles'

const PRE = `${i18nKeyPrefix}-BASICS-NETWORK-RATING-V2`

export default function NetworkRatingV2(props: {
  whitelabelRating: INetworkFilterFormOption | null | undefined
}) {
  const { whitelabelRating } = props
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  const whitelabel = useWhitelabel()
  const learnMoreLink = whitelabel.getAsset(AssetName.NETWORK_RATING_LEARN_MORE)
  const ratingSystemTitle = whitelabel.getAsset(AssetName.NETWORK_RATING_SYSTEM_TITLE)

  if (!ratingSystemTitle) {
    return null
  }

  return (
    <Bullet icon={<Star />}>
      <SpaceBetweenFlexSpan>
        <Strong>{t(ratingSystemTitle)}</Strong>
        <LinkWithLeftPaddingSometimes href={learnMoreLink} target="_blank">
          {t(`${PRE}-MORE`)}
        </LinkWithLeftPaddingSometimes>
      </SpaceBetweenFlexSpan>
      <Text muted>
        {(!whitelabelRating || whitelabelRating.slug === '-1') && (
          <>{t(`${PRE}-NOT-PARTICIPATING`)}</>
        )}

        {whitelabelRating && (
          <>
            {whitelabelRating.label}{' '}
            {whitelabel.networkRatingData().stars(whitelabelRating.symbolCount)}
          </>
        )}
      </Text>
    </Bullet>
  )
}
